import toNumber from "lodash.tonumber";
import React from "react";
import { Route, BrowserRouter, Routes, useParams } from "react-router-dom";
import PreviewPage from "./components/PreviewPage";
import Error404 from "./components/error/Error404";
import NoSuchLicense from "./components/error/NoSuchLicense";
import { getConfig } from "./config/config";
import { PreviewPageEnv } from "./constants/PreviewPageEnv";

interface IProps {
  env: PreviewPageEnv;
}

const getHeader = (env: PreviewPageEnv) =>
  `Sample page${env !== PreviewPageEnv.Production ? ` - ${env}` : ""}`;

const Page = ({ env }: IProps) => {
  const { license, group } = useParams<"license" | "group">();

  const licenseId = toNumber(license);
  const groupId = toNumber(group);

  if (!license || isNaN(licenseId)) {
    return <NoSuchLicense licenseId={license} />;
  } else {
    return (
      <PreviewPage
        header={getHeader(env)}
        licenseId={licenseId}
        groupId={groupId}
        config={getConfig(env)}
      />
    );
  }
};

const App: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route
        path="/preview/labs/:license/:group?"
        element={<Page env={PreviewPageEnv.Labs} />}
      />
      <Route
        path="/preview/staging/:license/:group?"
        element={<Page env={PreviewPageEnv.Staging} />}
      />
      <Route
        path="/preview/:license/:group?"
        element={<Page env={PreviewPageEnv.Production} />}
      />
      <Route element={<Error404 />} />
    </Routes>
  </BrowserRouter>
);

export default App;
